import {BaseModel} from '@/core/standard/BaseModel'; 
import UserTimeTrackingService from '@/modules/users/userTimeTracking/UserTimeTrackingService';
import { IUserTimeTrackingModel, UserTimeTrackingProtocol, IUserTimeTracking  } from '@/modules/users/userTimeTracking/IUserTimeTrackingModel';

const timeTracking = {
    id: null,
    is_active: false,
    start_time: "",
    end_time: "",
    signed_by_id: null,
    email: "",
    password: "",
};

class UserTimeTrackingModel extends BaseModel< IUserTimeTracking, UserTimeTrackingProtocol> {
    id= 0;
    is_active= false;
    start_time= "";
    end_time= "";
    signed_by_id= null;
    email= "";
    password= "";
    public modelName = 'userTimeTracking';

    public request = 'JSON';

    constructor() {
      super(timeTracking, UserTimeTrackingService);
    }

    public async updateSession(query: {id: string}) {
        return await UserTimeTrackingService.request({ url: query.id, query, method: "PUT" });
    }

    public async save(session: IUserTimeTrackingModel, toast) {
        if (session.id) {
          return await this.update(JSON.stringify(session), toast);
        } else {
          return await this.create(session, toast);
        }
    }
    
    public async downloadTimeTrackingFile(query: UserTimeTrackingProtocol) {
        return await this.service.downloadTimeTrackingFile({
          method: 'GET',
          query,
          headers: {Accept: '*/*'},
          responseType: 'blob',
        });
    }

}

export default UserTimeTrackingModel as new () => IUserTimeTracking;
